'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeLeaderboard = exports.fetchLeaderboard = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var _currencies = require('../../../utils/currencies');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * @function fetches fundraising pages ranked by funds raised
 */
var fetchLeaderboard = exports.fetchLeaderboard = function fetchLeaderboard() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  if (params.campaign && params.allPages) {
    return recursivelyFetchJGLeaderboard((0, _params.getUID)(params.campaign), params.q, params.limit);
  }

  switch ((0, _params.dataSource)(params)) {
    case 'event':
      return (0, _client.get)('/v1/events/leaderboard', {
        eventid: Array.isArray(params.event) ? params.event.map(_params.getUID) : (0, _params.getUID)(params.event),
        currency: (0, _currencies.currencyCode)(params.country),
        maxResults: params.limit
      }, {}, { paramsSerializer: _params.paramsSerializer }).then(function (response) {
        return response.pages.map(function (page) {
          return _extends({}, page, {
            raisedAmount: page.amount,
            eventName: response.eventName,
            currencyCode: response.currency,
            currencySymbol: (0, _currencies.currencySymbol)(response.currency)
          });
        });
      });
    default:
      var isTeam = params.type === 'team';

      return (0, _client.get)('donationsleaderboards/v1/leaderboard', _extends({}, params, {
        currencyCode: (0, _currencies.currencyCode)(params.country)
      }), {
        mappings: {
          charity: 'charityIds',
          campaign: 'campaignGuids',
          excludePageIds: 'excludePageGuids',
          limit: 'take',
          type: 'groupBy'
        },
        transforms: {
          type: function type(val) {
            return isTeam ? 'TeamGuid' : 'PageGuid';
          }
        }
      }, { paramsSerializer: _params.paramsSerializer }).then(function (response) {
        return response.results;
      }).then(function (results) {
        return filterLeaderboardResults(results, isTeam);
      }).then(function (results) {
        return mapLeaderboardResults(results, isTeam);
      });
  }
};

var filterLeaderboardResults = function filterLeaderboardResults() {
  var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isTeam = arguments[1];

  return results.filter(function (result) {
    return isTeam ? result.team : result.page;
  });
};

var mapLeaderboardResults = function mapLeaderboardResults() {
  var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isTeam = arguments[1];

  return results.map(function (result) {
    return isTeam ? _extends({}, result, result.team, {
      eventName: [result.team.captain.firstName, result.team.captain.lastName].join(' '),
      pageImages: [result.team.coverImageName],
      numberOfSupporters: result.team.numberOfSupporters
    }) : _extends({}, result, result.page, {
      eventName: [result.page.owner.firstName, result.page.owner.lastName].join(' '),
      pageImages: [result.page.photo],
      pageShortName: result.page.shortName,
      numberOfSupporters: result.donationCount
    });
  });
};

var recursivelyFetchJGLeaderboard = function recursivelyFetchJGLeaderboard(campaign, q) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var results = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var page = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

  var options = {
    params: { page: page, q: q }
  };

  return _client.servicesAPI.get('/v1/justgiving/campaigns/' + campaign + '/leaderboard', options).then(function (response) {
    return response.data;
  }).then(function (data) {
    var _data$meta = data.meta,
        currentPage = _data$meta.currentPage,
        totalPages = _data$meta.totalPages;

    var updatedResults = [].concat(_toConsumableArray(results), _toConsumableArray(data.results));

    if (currentPage === totalPages || page * 10 >= limit) {
      return updatedResults;
    } else {
      return recursivelyFetchJGLeaderboard(campaign, q, limit, updatedResults, page + 1);
    }
  });
};

/**
 * @function a default deserializer for leaderboard pages
 */
var deserializeLeaderboard = exports.deserializeLeaderboard = function deserializeLeaderboard(supporter, index) {
  var subdomain = (0, _client.isStaging)() ? 'www.staging' : 'www';

  return {
    currency: supporter.currencyCode,
    currencySymbol: supporter.currencySymbol,
    donationUrl: 'https://' + subdomain + '.justgiving.com/fundraising/' + supporter.pageShortName + '/donate',
    id: supporter.pageId,
    image: supporter.defaultImage || (supporter.pageImages ? 'https://images' + subdomain.replace('www', '') + '.jg-cdn.com/image/' + supporter.pageImages[0] + '?template=Size200x200' : supporter.pageOwner ? 'https://' + subdomain + '.justgiving.com/fundraising/images/user-profile/' + supporter.pageOwner.accountId : null),
    name: supporter.pageTitle || supporter.name || supporter.pageOwner && supporter.pageOwner.fullName,
    position: index + 1,
    raised: parseFloat(supporter.amount || supporter.raisedAmount || supporter.amountRaised || supporter.donationAmount || 0),
    slug: supporter.pageShortName,
    subtitle: supporter.eventName,
    target: supporter.targetAmount || supporter.target,
    totalDonations: supporter.numberOfSupporters,
    url: 'https://' + subdomain + '.justgiving.com/' + supporter.pageShortName
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/leaderboard/justgiving/index.js
// module id = 1413
// module chunks = 0